String.prototype.startsWith || (String.prototype.startsWith = function (t, r) {
  return r = r || 0, this.substr(r, t.length) === t;
});